import { curveStepAfter } from 'd3-shape';
import {
    AnySelection,
    seriesSvgLine,
    seriesSvgMulti,
    seriesSvgArea,
} from '@d3fc/d3fc-series';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';
import { OrderFill } from '../../fillsGraphData';

export function createLimitPriceSeries(
    yStart: number,
    yEnd: number,
    position: PortfolioPosition | undefined,
    limitPriceAccessor: (d: OrderFill) => number | undefined
) {
    const line = seriesSvgLine()
        .crossValue(deriveTime)
        .mainValue(limitPriceAccessor)
        .curve(curveStepAfter)
        .decorate((s: AnySelection) => s.classed('limitPriceLine', true));

    const isBuyPosition = position && position.side === 'B';

    const baseValueFn = isBuyPosition ? limitPriceAccessor : () => yStart;
    const mainValueFn = isBuyPosition ? () => yEnd : limitPriceAccessor;

    const area = seriesSvgArea()
        .crossValue(deriveTime)
        .baseValue(baseValueFn)
        .mainValue(mainValueFn)
        .curve(curveStepAfter)
        .decorate((s: AnySelection) => s.classed('limitPriceArea', true));

    return seriesSvgMulti().series([area, line]);
}
